import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ApplicationItem } from '../../applications/models/applicationItem';
import { TileService } from '../services/tile.service';
@Component({
  selector: 'app-tile',
  templateUrl: './tile.component.html',
  standalone: true,
  imports: [
    CommonModule, DragDropModule

  ],
  styleUrls: ['./tile.component.scss']
})
export class TileComponent {
  @Input() tile: Tile = new Tile();
  @Input() index: number = -1;
  @Input() size: string = "xlarge";
  @Input() draggable: boolean = true;
  @Input() tileTemplate: any;

  @Output() ispinnedchange = new EventEmitter<Tile>();

  constructor(private service: TileService) {
  
  }

  async onIsPinned() {
    this.tile.ispinned = !this.tile.ispinned;
    if (this.tile.title == 'Assessments' && this.tile.size == 'xlarge') {
      var formData = new FormData();
      formData.append('surveyid', this.tile.data.assessmentList.id);
      formData.append('surveyname', this.tile.data.assessmentList.name);
      var currentId=this.tile.data.assessmentList.uniqueId;
      await this.service.savePinnedAssessment(formData).then((data) => {});
      await this.service.GetAssessmentDbData().then((data) => {
        let surveyId = this.tile.data.assessmentList.id;
        let surveyName = this.tile.data.assessmentList.name;
        var assessItem: ApplicationItem[] = [] = data;
        //var currentId = "" + assessItem.filter(x => x.surveyId == surveyId && x.text == surveyName)[0]?.id;
        this.tile.id = currentId;
        if (this.tile.ispinned) {
          this.service.pinTile(this.tile.id, this.tile.type);
          reloadPage(this.tile.type);
        }
        else {
          this.service.unpinTile(this.tile.id);
          reloadPage(this.tile.type);
        }
      });
    }
    else {
      if (this.tile.ispinned) {
        if (this.tile.title == 'Whiteboards') {
          await this.service.pinMiroTile(this.tile.id, this.tile.type);

        } else {
          await this.service.pinTile(this.tile.id, this.tile.type);
        }
        reloadPage(this.tile.type);
      }
      else {
        if (this.tile.title == 'Whiteboards') {
          await this.service.unpinMiroTile(this.tile.id);

        } else {
          await this.service.unpinTile(this.tile.id);

        }
        reloadPage(this.tile.type);
      }
    }
    await this.ispinnedchange.emit(this.tile);
  }
}

function reloadPage(appType: string) {
  if (appType == 'application') {
    window.location.reload();
  }
}

export class Tile {
  id: string = "00000000-0000-0000-0000-000000000000";
  color: string = "blue";
  type: string = "unset";
  title: string = "Title";
  size: string = "small";
  cssclass: string = "";
  applicationType?: string = "";
  peopleIcon?: string = "";
  ispinned: boolean = false;
  data?: any = {};
}
